// eslint-disable-next-line @typescript-eslint/triple-slash-reference
/// <reference path="../dist/gui.d.ts" />

export default class TestRect {

    public constructor(app: vf.Application, uiStage: vf.gui.Stage) {
        this.onLoad(app, uiStage)
    }
    private _rect?: vf.gui.Rect;
    private _rectPoint?: vf.gui.Rect;
    private _rect1?: vf.gui.Rect;
    private _buttonList: vf.gui.Label[] = [];

    private onRelease() {
        if (this._rect) {
            this._rect.removeAllListeners();
            this._rect.parent && this._rect.parent.removeChild(this._rect);
            this._rect.release();
            this._rect = undefined;
        }
        if (this._rectPoint) {
            this._rectPoint.removeAllListeners();
            this._rectPoint.parent && this._rectPoint.parent.removeChild(this._rectPoint);
            this._rectPoint.release();
            this._rectPoint = undefined;
        }
        if (this._rect1) {
            this._rect1.removeAllListeners();
            this._rect1.parent && this._rect1.parent.removeChild(this._rect1);
            this._rect1.release();
            this._rect1 = undefined;
        }
        if (this._buttonList && this._buttonList.length > 0) {
            this._buttonList.forEach(element => {
                element.removeAllListeners();
                element.parent && element.parent.removeChild(element);
                element.release();
            });
            this._buttonList = [];
        }
    }

    private onLoad(app: vf.Application, uiStage: vf.gui.Stage) {

        /** 绘制矩形 */
        const rect = this._rect = new vf.gui.Rect();
        rect.style.left = 100;
        rect.style.top = 100;
        rect.style.width = 200;
        rect.style.height = 200;
        rect.style.fillColor = [255, 0, 0, 0.5];
        rect.style.lineColor = [255, 255, 255, 1];
        rect.style.lineWidth = 1;
        rect.radius = 10; //圆角
        rect.anchorX = 0.5;
        rect.anchorY = 0.5;
        uiStage.addChild(rect);


        /** 绘制矩形 */
        const rectPoint = this._rectPoint = new vf.gui.Rect();
        rectPoint.style.left = 300;
        rectPoint.style.top = 300;
        rectPoint.style.width = 40;
        rectPoint.style.height = 40;
        rectPoint.style.fillColor = [255, 0, 0, 1];
        rectPoint.style.lineColor = [255, 255, 255, 1];

        rectPoint.lineWidth = 1;
        uiStage.addChild(rectPoint);

        /** 绘制透明矩形 */
        const rect1 = this._rect1 = new vf.gui.Rect();
        rect1.style.left = 100;
        rect1.style.top = 250;
        rect1.style.width = 100;
        rect1.style.height = 100;
        rect1.style.fillColor = [];
        rect1.style.lineColor = [255, 255, 255, 1];
        rect1.lineWidth = 1;
        rect1.radius = 40; //圆角，最大值为 width/2

        uiStage.addChild(rect1);



        const click = new vf.gui.Interaction.ClickEvent(rect, true);
        rect.on(vf.gui.Interaction.TouchMouseEvent.onUp, this.onClick, this);
        rect.on(vf.gui.Interaction.TouchMouseEvent.onDown, this.onClick, this);
        rect.on(vf.gui.Interaction.TouchMouseEvent.onPress, this.onClick, this);
        rect.on(vf.gui.Interaction.TouchMouseEvent.onMove, this.onClick, this);
        rect.on(vf.gui.Interaction.TouchMouseEvent.onHover, this.onClick, this);
        rect.on(vf.gui.Interaction.TouchMouseEvent.onClick, this.onClick, this);


        this.getButton('设置/取消radius', () => {

            if (rect.radius == 0) {

                rect.radius = 0;
            } else {
                rect.radius = 10;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消lineColor', () => {

            if (rect.lineColor!= "#00ff00") {

                rect.lineColor = "#00ff00";
            } else {
                rect.lineColor = "#ffffff";
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消lineWidth', () => {

            if (rect.lineWidth != 10) {

                rect.lineWidth = 10;
            } else {
                rect.lineWidth = 1;
            }
        }, uiStage, 650, 0);






        this.getButton('设置/取消color', () => {

            if (rect.color != "#ffffff") {

                rect.color = "#ffffff";
            } else {
                rect.color = "#00ff00";
            }
        }, uiStage, 650, 0);



        this.getButton('设置/取消anchorX', () => {

            if (rect.anchorX != 0.9) {

                rect.anchorX = 0.9;
            } else {
                rect.anchorX = 0.5;
            }
        }, uiStage, 650, 0);


        this.getButton('设置/取消anchorY', () => {

            if (rect.anchorY != 0.9) {

                rect.anchorY = 0.9;
            } else {
                rect.anchorY = 0.5;
            }
        }, uiStage, 650, 0);




        this.getButton('设置/取消 fillColor', () => {
            if (rect.style.fillGradientType !== 0) {
                console.log("111")
                rect.style.fillGradientType = 1
                rect.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                rect.style.fillColor = [[0, 171, 235, 1], [255, 255, 255, 1], [38, 192, 0, 1], [255, 0, 0, 0.5]];
            } else {
                rect.style.fillGradientType = 0
                rect.style.fillGradientStops = [0, 0.5, 0.5, 1] // 渐变分布
                rect.style.fillColor = [[0, 171, 235, 1], [255, 255, 255, 1], [38, 192, 0, 1], [255, 0, 0, 0.5]];
            }

            let index = 0.5;
            const ticker = vf.gui.Scheduler.setInterval(60, () => {

                if (index > 1) {
                    index = 1;
                    ticker.stop();
                } else {
                    index = index + 0.01;
                }
                rect.style.fillGradientStops = [0, 0.5, 0.5, index]
            });

        }, uiStage, 650, 0);

    }


    private onClick(e: vf.gui.Interaction.InteractionEvent) {
        console.log(e.type);
    }


    private posY = 15;
    private getButton(title: string, clickFun: Function, target: any, x: number, y: number) {
        const button = new vf.gui.Label;
        button.style.fontSize = 30;
        button.style.fontFamily = 'PingFang-SC-Medium,PingFang-S';
        button.style.fontWeight = 500;
        button.style.color = 0xffffff;
        button.style.lineHeight = 45;
        button.text = title;
        button.interactabled = true;
        button.x = x;
        button.y = this.posY;
        button.on(vf.gui.Interaction.TouchMouseEvent.onClick, clickFun);
        target.addChild(button);
        this.posY = this.posY + 30 + y;
        this._buttonList.push(button);
        return button;
    }

}
